import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useCallback, useContext } from 'react';
import "../../index.css";
import axios from 'axios';
import { FaTag } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../../context/AppContext";
import Footer from '../Common_Components/Footer';

function LearningMaterials() {
    const location = useLocation();
    const navigate = useNavigate();
    const { Translate } = useContext(ProductContext);
    const [activePage, setActivePage] = useState("");



    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon
                                onClick={() => navigate(-1)}
                                className='icon_1'
                            />
                            <h2>{Translate?.message?.data?.LearningMaterials}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-div-section">
                <div className="content-box-day-module">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="daymodule-image">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/learning5.png`}
                                        alt="Japan"
                                    />
                                </div>
                               
                                    <div className="row" >
                                        <div className="button-wrapper">
                                            <button
                                                className='learn-script-content-day-module'
                                                onClick={() => navigate('/HiraganaWorksheet')}
                                            >
                                                <div className="module-text-learn-script">
                                                    <div className="module-text-learn-script22">
                                                            {/* <div
                                                                style={{
                                                                    textAlign: "left",
                                                                    width: '100%',
                                                                    display: 'inline-block',
                                                                    paddingBottom: 10
                                                                }}
                                                            >
                                                                <FaTag color="#ffc0cb" size={20} style={{ display: 'inline-block' }} />
                                                                <p
                                                                    style={{
                                                                        color: "#ffc0cb",
                                                                        fontSize: 14,
                                                                        paddingLeft: 15,
                                                                        fontWeight: '600',
                                                                        display: 'inline-block'
                                                                    }}
                                                                >
                                                                    Hello
                                                                </p>
                                                            </div> */}
                                                       
                                                    </div>
                                                    <h2>{Translate?.message?.data?.HiraganaWorksheet}</h2>
                                                </div>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                                    className="daymodule-icon"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row" >
                                        <div className="button-wrapper">
                                            <button
                                                className='learn-script-content-day-module'
                                                onClick={() => navigate('/KatakanaWorksheet')}
                                            >
                                                <div className="module-text-learn-script">
                                                    <div className="module-text-learn-script22">
                                                       
                                                    </div>
                                                    <h2>{Translate?.message?.data?.KatakanaWorksheet}</h2>
                                                </div>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                                    className="daymodule-icon"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row" >
                                        <div className="button-wrapper">
                                            <button
                                                className='learn-script-content-day-module'
                                                onClick={() => navigate('/KanjiWorksheet')}
                                            >
                                                <div className="module-text-learn-script">
                                                    <div className="module-text-learn-script22">
                                                       
                                                    </div>
                                                    <h2>{Translate?.message?.data?.Kanjiworksheet}</h2>
                                                </div>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                                    className="daymodule-icon"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row" >
                                        <div className="button-wrapper">
                                            <button
                                                className='learn-script-content-day-module'
                                                onClick={() => navigate('/Vocab')}
                                            >
                                                <div className="module-text-learn-script">
                                                    <div className="module-text-learn-script22">
                                                       
                                                    </div>
                                                    <h2>{Translate?.message?.data?.Vocabworksheet}</h2>
                                                </div>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                                    className="daymodule-icon"
                                                />
                                            </button>
                                        </div>
                                    </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      <Footer />
    </div>
  );
}

export default LearningMaterials
